import React from "react";
import { CheckCircle2 } from "lucide-react";

// Step indicator component
const StepIndicator = ({ currentStep, steps }) => {
  return (
    <div className="flex items-center justify-center mb-8" data-testid="step-indicator">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center">
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                index < currentStep
                  ? "bg-saturn-orange text-white"
                  : index === currentStep
                  ? "bg-saturn-orange/20 border-2 border-saturn-orange text-saturn-orange"
                  : "bg-slate-800 text-slate-500"
              }`}
              data-testid={`step-${index}-indicator`}
            >
              {index < currentStep ? (
                <CheckCircle2 className="w-5 h-5" />
              ) : (
                <step.icon className="w-5 h-5" />
              )}
            </div>
            <span
              className={`text-xs mt-2 font-rajdhani uppercase tracking-wider ${
                index <= currentStep ? "text-saturn-orange" : "text-slate-500"
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`w-16 h-0.5 mx-2 ${
                index < currentStep ? "bg-saturn-orange" : "bg-slate-700"
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;
